import { Col, Row, Form } from "antd";
import { LeftCircleOutlined } from "@ant-design/icons";
import "../../newMain/Modals/PayWithCash/style.css";

const numbers = [
  1,
  2,
  3,
  "backspace",
  4,
  5,
  6,
  50,
  7,
  8,
  9,
  100,
  "C",
  "0",
  ".",
  "00",
];

const Calculator = ({ handleButtonClick }: any) => {
  return (
    <>
      <Form layout="vertical">
        <Row gutter={[5, 5]}>
          {numbers.map((num) => (
            <Col md={6} key={`${num}`}>
              <div
                style={{ fontWeight: "bold", fontSize: "20px" }}
                onClick={() => {
                  handleButtonClick(num);
                }}
                className={
                  num === 50 || num === 100 || num === "00" ? "dark" : "light"
                }
              >
                {num === "backspace" ? (
                  <LeftCircleOutlined
                    style={{ color: "red", fontSize: "24px" }}
                  />
                ) : (
                  num
                )}
              </div>
            </Col>
          ))}
        </Row>
      </Form>
    </>
  );
};
export default Calculator;
